import { UseFormReturn } from "react-hook-form";
import { useState } from "react";
import { Step } from "./constants";
import { CaretLeft } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { DrawerHeader } from "@/components/ui/drawer";
import { useTranslation } from "react-i18next";
import { ExpenseFormValues } from ".";
import { Input } from "@/components/ui/input";

const AmountStep = ({
  form,
  setStep,
}: {
  form: UseFormReturn<ExpenseFormValues>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState<number | undefined>(
    form.getValues("amount")
  );
  return (
    <div>
      <DrawerHeader
        title={t("label.add_amount")}
        leftButton={
          <button type="button" onClick={() => setStep(Step.INITAL)}>
            <CaretLeft color="#E3EDFC" size={18} />
          </button>
        }
        rightButton={<span className="w-[18px]" />}
      />

      <Input
        type="number"
        data-testid="expense-form-amount-input"
        placeholder={t("label.enter_amount")}
        value={amount ?? ""}
        onChange={(e) => {
          const value = e.target.value;
          if (!value) {
            setAmount(undefined);
          } else {
            setAmount(parseFloat(value));
          }
        }}
      />

      <Button
        data-testid="expense-form-amount-submit-button"
        className="mt-4 w-full"
        onClick={() => {
          form.setValue("amount", amount);
          setStep(Step.INITAL);
        }}
      >
        {t("button.add")}
      </Button>
    </div>
  );
};

export default AmountStep;
